/* eslint-disable no-undef */
/* eslint-disable no-use-before-define */
/* eslint-disable sonarjs/no-duplicate-string */

'use strict';

var $shipping = $('.shipping-content');

/**
 * clear shipping form
 */
var clearForm = function () {
    $shipping.addClass('js-from-alt-shipping');
    $shipping.find('.shippingAddressOne').val('');
    $shipping.find('.shippingAddressTwo').val('');
    $shipping.find('.shippingAddressCity').val('');
    $shipping.find('.shippingZipCode').val('');
    $shipping.find('.shippingState').val('');
    $shipping.find('.additional-address-fields').addClass('d-none');
    $('#bossShipToStoreError').hide();
    if ($('.boss-store').length && $('.boss-store.store-selected').length) {
        $('.boss-store.store-selected').find('input').prop('checked', null).parents('.boss-store')
            .removeClass('store-selected');
        $('.boss-store-id').val('');
    }
    $('.yamato-pickup').val('');
};

/**
 * Hide long form shipping form and switch to minimal
 * @param {string} type - current shipping type
 */
var minimalShippingForm = function (type) {
    if (!$('.shipping-address-block').is(':visible')) {
        $('.shipping-address-block').css('display', 'block');
    }

    $shipping.find('.shippingAddressOne').parent().css('display', 'none');
    $shipping.find('.shippingAddressTwo').parent().css('display', 'none');
    $shipping.find('.shippingAddressCity').parent().css('display', 'none');
    $shipping.find('.shippingZipCode').parent().css('display', 'none');
    $shipping.find('.shippingState').parent().css('display', 'none');

    if (type === 'access-point') {
        $shipping.find('.access-point-message').css('display', 'block');
        $shipping.find('.access-point').css('display', 'block');
        $('.boss-store-list').css('display', 'none');
    } else if (type === 'boss') {
        $('.boss-store-list').css('display', 'flex');
        $shipping.find('.access-point-message').css('display', 'none');
        $shipping.find('.access-point').css('display', 'none');
    } else if (type === 'cvs') {
        $('.submit-shipping').addClass('d-none');
        $('.js-cvs-store-wrapper').removeClass('d-none');
        $shipping.find('.js-conveniencestore-disclaimer').removeClass('d-none');
    } else if (type === 'yamato') {
        $('.submit-shipping').addClass('d-none');
        $('.js-yamato-wrapper').removeClass('d-none');
    }

    if ($('.shipping-address-block').hasClass('d-none')) {
        $('.shipping-address-block').removeClass('d-none');
    }
    if ($('.shipment-selector-block').length > 0) {
        $('.shipment-selector-block').addClass('d-none');
    }
    if ($('.save-address-to-NB').length > 0) {
        $('.save-address-to-NB').addClass('d-none');
        $shipping.find('#saveShippingAddr').prop('checked', false);
    }
    if ($('.border-add-address').length > 0) {
        $('.border-add-address').addClass('d-none');
    }
};

/**
 * Select shipping type when access point is active.
 * @param {string} type - current shipping type
 */
// eslint-disable-next-line sonarjs/cognitive-complexity
var selectShippingType = function (type) {
    var isAmzPayExpressFlow = $('#checkout-main').attr('data-is-amzpay-expressflow') === 'true';
    $shipping.removeClass('shipping-type-regular shipping-type-access-point shipping-type-boss shipping-type-cvs shipping-type-yamato');
    $shipping.find('.access-point-message').removeClass('d-none');
    $shipping.find('.access-point').removeClass('d-none');
    $shipping.find('.access-points-list').css('display', 'none');

    if (type === 'regular') {
        $shipping.addClass('shipping-type-regular');
        $shipping.find('.field-shipping-access-point').prop('checked', false);
        $shipping.find('.field-shipping-boss').prop('checked', false);
        $shipping.find('.field-shipping-cvs').prop('checked', false);
        $shipping.find('.field-shipping-yamato').prop('checked', false);
        $shipping.find('.field-shipping-regular').prop('checked', true);
        $shipping.find('.access-point').css('display', 'none');
        $shipping.find('.access-point-message').css('display', 'none');
        $('.boss-store-list').css('display', 'none');
        var addressList = $('.name-address-wrapper');
        var customerType = $('#checkout-main').attr('data-customer-type');

        if (window.sitePrefs.cvsPickupEnabled) {
            $('.shipping-address, .billing-address').find('input[type=tel]').removeAttr('pattern');
        }

        $shipping.find('.shippingAddressOne').parent().css('display', 'block');
        $shipping.find('.shippingAddressTwo').parent().css('display', 'block');
        $shipping.find('.shippingAddressCity').parent().css('display', 'block');
        $shipping.find('.shippingZipCode').parent().css('display', 'block');
        $shipping.find('.shippingState').parent().css('display', 'block');
        $('.submit-shipping').removeClass('d-none');
        $('.js-cvs-store-wrapper').addClass('d-none');
        $shipping.find('.js-conveniencestore-disclaimer').addClass('d-none');
        $('.yamato-store-info').addClass('d-none');
        $('.js-yamato-wrapper').addClass('d-none');

        $('.cvs-store-selected').val('');

        if (!$('.shipping-address').find('.alert').is(':visible') && $('.shipping-address-block').length > 0 && $('.shipping-address-block').length > 0 && customerType !== 'guest' && addressList.length > 0 && !isAmzPayExpressFlow) {
            $('.shipping-address-block').addClass('d-none');
        }
        if ($('.shipment-selector-block').hasClass('d-none') && addressList.length > 0 && !isAmzPayExpressFlow) {
            $('.shipment-selector-block').removeClass('d-none');
        }
        if ($('.save-address-to-NB').hasClass('d-none') && !isAmzPayExpressFlow) {
            $('.save-address-to-NB').removeClass('d-none');
            $shipping.find('#saveShippingAddr').prop('checked', true);
        }
        if ($('.border-add-address').hasClass('d-none') && !isAmzPayExpressFlow) {
            $('.border-add-address').removeClass('d-none');
        }
    } else if (type === 'boss') {
        $shipping.addClass('shipping-type-boss');
        $shipping.find('.field-shipping-regular').prop('checked', false);
        $shipping.find('.field-shipping-access-point').prop('checked', false);
        $shipping.find('.field-shipping-boss').prop('checked', true);

        minimalShippingForm(type);
    } else if (type === 'access-point') {
        $shipping.addClass('shipping-type-access-point');
        $shipping.find('.field-shipping-regular').prop('checked', false);
        $shipping.find('.field-shipping-boss').prop('checked', false);
        $shipping.find('.field-shipping-access-point').prop('checked', true);

        minimalShippingForm(type);
    } else if (type === 'cvs') {
        $shipping.addClass('shipping-type-cvs');
        $shipping.find('.field-shipping-regular').prop('checked', false);
        $shipping.find('.field-shipping-boss').prop('checked', false);
        $shipping.find('.field-shipping-cvs').prop('checked', true);

        minimalShippingForm(type);
    } else if (type === 'yamato') {
        $shipping.addClass('shipping-type-yamato');
        $shipping.find('.field-shipping-regular').prop('checked', false);
        $shipping.find('.field-shipping-yamato').prop('checked', true);

        minimalShippingForm(type);
    }

    var $shippingForm = $('.shipping-form');
    var shippingHelpers = require('./shipping');
    shippingHelpers.methods.updateShippingMethodList($shippingForm);
};

/**
 * Updates regular shipping form. (Not BOSS or Access Point form)
 */
var updateRegularShippingForm = function () {
    var selectedAddress = $('.single-shipping .shipping-form').find('.custom-dropdown.shippingAddressSelector').find(':selected');
    var addressList = $('.name-address-wrapper');
    var customerType = $('#checkout-main').attr('data-customer-type');
    var isAmzPayExpressFlow = $('#checkout-main').attr('data-is-amzpay-expressflow') === 'true';
    if (customerType !== 'registered' && !isAmzPayExpressFlow) { // do not clear the html address fields in case of AP Express Flow as then the address selected in Amazon is then cleared out
        clearForm();
    } else if (customerType === 'registered' && addressList.length > 0 && !isAmzPayExpressFlow) {
        // Names for form field classes and associated data attributes
        // do not copy the address from customer saved address in case of AP Express Flow as then the address selected in Amazon is then cleared out
        var fieldDataNames = [
            ['FirstName', 'first-name'],
            ['LastName', 'last-name'],
            ['firstNamePhonetic', 'first-name-phonetic'],
            ['LastNamePhonetic', 'last-name-phonetic'],
            ['AddressOne', 'address1'],
            ['AddressTwo', 'address2'],
            ['AddressThree', 'address3'],
            ['AddressCity', 'city'],
            ['State', 'state-code'],
            ['ZipCode', 'postal-code'],
            ['PhoneNumber', 'phone']
        ];
        fieldDataNames.forEach(function (name) {
            var $formField = $shipping.find('.shipping' + name[0]);
            var data = selectedAddress.attr('data-' + name[1]);
            if ($formField.length && data) {
                $formField.val(data);
            }
        });
    }
    $('.yamato-pickup').val(''); // clear yamato pickup when regular shipping is selected
};

/**
 * Check if shipping is set to regular and not Access Point or Buy online and ship to store
 */
var isShippingRegular = function () {
    var checkoutMain = $('#checkout-main');
    var checkoutStage = checkoutMain.attr('data-checkout-stage');

    if ($shipping.is('.shipping-type-regular') && checkoutStage === 'shipping') {
        updateRegularShippingForm();
        selectShippingType('regular');
    }
};

// Event listener for regular shipping
var addEventListeners = function () {
    $shipping.on('click', '#ap-shipping-type-selector-regular', function (e) {
        e.stopImmediatePropagation();
        if (!$(this).is(':checked')) {
            clearForm();
        }
        updateRegularShippingForm();
        selectShippingType('regular');
    });
};

module.exports = {
    minimalShippingForm: minimalShippingForm,
    selectShippingType: selectShippingType,
    isShippingRegular: isShippingRegular,
    clearForm: clearForm,
    addEventListeners: addEventListeners
};
